import Vue from 'vue';
import VueGtag from 'vue-gtag';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
// import PdfViewer from './plugins/pdf-viewer';
import axiosInstance from './axiosInstance';
import authConfig from './auth/auth.config';
import { MsalPlugin } from './auth/msal-plugin';

// Vue.use(PdfViewer, {
//   clientId: process.env.VUE_APP_ADOBE_API_KEY,
//   locale: 'fr-FR',
//   baseURL: process.env.VUE_APP_AXIOS_BASE_URL,
// });

Vue.use(VueGtag, {
  config: {
    id: 'G-421N0GZGLJ',
    params: {
      anonymize_ip: true,
    },
  },
}, router);

Vue.use(MsalPlugin, authConfig);

Vue.filter('formatDate', (date) => {
  if (!date) return '';
  const [year, month, day] = date.split('-');
  return `${day}/${month}/${year}`;
});

Vue.prototype.$http = axiosInstance;

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
